import React from 'react';
import { TOOLBARS, getModalStyles } from 'wix-rich-content-common';
import { InsertVideoIcon } from '../icons';
import { Modals } from '../modals';
import ToolbarIconTooltip from '../../../components/ToolbarIconTooltip';
import linkModalConfig from './link-modal.config';
export default (function (_a) {
    var helpers = _a.helpers, t = _a.t;
    return [
        {
            type: 'modal',
            name: 'Video',
            Icon: function () { return (React.createElement(ToolbarIconTooltip, { tooltipTextKey: 'editorToolbar.tooltips.addVideo' },
                React.createElement(InsertVideoIcon, null))); },
            componentData: linkModalConfig,
            modalName: Modals.VIDEO_LINK,
            modalStyles: getModalStyles({ fullScreen: false }),
            helpers: helpers,
            toolbars: [TOOLBARS.FOOTER, TOOLBARS.SIDE],
        },
    ];
});
//# sourceMappingURL=insert-buttons.js.map